import { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  Newspaper,
  Robot,
  Cpu,
  Rocket,
  Buildings,
  CurrencyDollar,
  Code,
  CalendarBlank,
  GraduationCap,
  ChartBar,
  Storefront,
  Flask,
  Brain,
} from "@phosphor-icons/react";

const NAV_ITEMS = [
  { to: "/trending-ai",             label: "Dashboard",    icon: Brain,    end: true },
  { to: "/trending-ai/news",        label: "AI News",      icon: Newspaper },
  { to: "/trending-ai/models",      label: "AI Models",    icon: Cpu },
  { to: "/trending-ai/agents",      label: "AI Agents",    icon: Robot },
  { to: "/trending-ai/research",    label: "Research",     icon: Flask },
  { to: "/trending-ai/companies",   label: "Companies",    icon: Buildings },
  { to: "/trending-ai/startups",    label: "Startups",     icon: Rocket },
  { to: "/trending-ai/funding",     label: "Funding",      icon: CurrencyDollar },
  { to: "/trending-ai/coding",      label: "AI Coding",    icon: Code },
  { to: "/trending-ai/events",      label: "Events",       icon: CalendarBlank },
  { to: "/trending-ai/learning",    label: "Learning",     icon: GraduationCap },
  { to: "/trending-ai/benchmarks",  label: "Benchmarks",   icon: ChartBar },
  { to: "/trending-ai/marketplace", label: "Marketplace",  icon: Storefront },
];

export default function AINavBar() {
  const location = useLocation();
  const [visible, setVisible] = useState(true);
  const lastY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      // Always show near top of page
      if (y < 80) { setVisible(true); lastY.current = y; return; }
      // Show when scrolling up, hide when scrolling down
      setVisible(y <= lastY.current);
      lastY.current = y;
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    // On mobile: slide behind the header when scrolling down.
    // On desktop (md+): always visible (md:translate-y-0 overrides the hide).
    <div
      className={`sticky top-16 z-30 bg-white border-b border-slate-200 shadow-sm transition-transform duration-300 ${
        visible ? "translate-y-0" : "-translate-y-full md:translate-y-0"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <nav
          className="flex items-center gap-0 overflow-x-auto hide-scrollbar -mb-px"
          aria-label="AI Platform navigation"
        >
          {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => {
                const active = isActive || (!end && location.pathname === to);
                return `flex items-center gap-1.5 px-3 py-3 text-xs font-medium border-b-2 transition-colors whitespace-nowrap shrink-0 focus:outline-none ${
                  active
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent text-slate-500 hover:text-slate-900 hover:border-slate-300"
                }`;
              }}
            >
              <Icon size={13} weight="fill" />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
